export default {
  USER: 'gp_consult_af_user',
  AUTH_TOKEN: 'gp_consult_af_token'
}